import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import ChatService from 'domain/services/chat/ChatServices';

export const fetchAllMessages = createAsyncThunk(
  'specificChat/fetchAllMessages',
  async (data: string) => {
    const propsData = {
      offset: 0,
      chat_id: data,
      limit: 50,
    };
    try {
      const allMessages = await ChatService.getPreviousMessages(propsData);
      return allMessages.chat_messages;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const togglePinMessage = createAsyncThunk(
  'specificChat/togglePinMessage',
  async (data: any) => {
    const propsData = {
      offset: 0,
      chat_id: data.chatId,
      limit: 50,
    };
    try {
      await ChatService.pinMessages(data.data);
      const allMessages = await ChatService.getPreviousMessages(propsData);
      return allMessages.chat_messages;
    } catch (error) {
      throw new Error(error);
    }
  }
);

interface SpecificChat {
  error: string;
  loading: 'idle' | 'pending' | 'success' | 'failed';
  allMessages: any;
  chatUpdated: any;
  activeChat: string;
  pinToggled: boolean;
  respondingClicked: object;
}

const initialState = {
  loading: 'idle',
  pinToggled: true,
  allMessages: [],
  chatUpdated: 1,
  activeChat: '',
  respondingClicked: { id: null },
} as SpecificChat;

const specificChatSlice = createSlice({
  name: 'directMessages',
  initialState,
  reducers: {
    setActiveChat(state, action: PayloadAction<string>) {
      state.activeChat = action.payload;
    },
    setRespondingClicked(state, action: PayloadAction<any>) {
      state.respondingClicked = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchAllMessages.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(fetchAllMessages.fulfilled, (state, action) => {
      state.loading = 'success';
      state.allMessages = action.payload;
    });
    builder.addCase(fetchAllMessages.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
    builder.addCase(togglePinMessage.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(togglePinMessage.fulfilled, (state, action) => {
      state.loading = 'success';
      state.allMessages = action.payload;
      state.pinToggled = !state.pinToggled;
    });
    builder.addCase(togglePinMessage.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

export const selectAllMessages = state => state.specificChat.allMessages;
export const selectChatUpdated = state => state.specificChat.chatUpdated;
export const selectAtiveChat = state => state.specificChat.activeChat;
export const selectRespondingClicked = state => state.specificChat.respondingClicked;
export const { setActiveChat, setRespondingClicked } = specificChatSlice.actions;

export const selectPinToggled = state => state.specificChat.pinToggled;
export default specificChatSlice.reducer;
